import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wx.png'
import _imports_1 from '../assets/zfb.png'


const _withScopeId = n => (_pushScopeId("data-v-339ffa88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "nameOrphone" }
const _hoisted_5 = { class: "address" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "productName" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = { class: "select" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 商品总价: ")
const _hoisted_12 = { class: "totalPrice" }
const _hoisted_13 = { class: "aggregate" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 总计: ")
const _hoisted_15 = { class: "aggregatePrice" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "支付方式", -1))
const _hoisted_19 = { class: "value" }
const _hoisted_20 = {
  key: 0,
  style: {"height":"0.32rem"},
  src: _imports_0,
  alt: ""
}
const _hoisted_21 = {
  key: 1,
  style: {"height":"0.32rem"},
  src: _imports_1,
  alt: ""
}
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "支付时间", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单编号", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = {
  key: 0,
  class: "flex",
  style: {"flex-direction":"column","align-items":"start"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单备注", -1))
const _hoisted_30 = { class: "remarks" }

import { ref, reactive } from "vue";
import { useRouter } from "vue-router";
import router from "@/router";
import { useRoute } from "vue-router";
import {
  Button,
  Field,
  Cell,
  CellGroup,
  Toast,
  NavBar,
  Tabs,
  Tab,
  List,
  Icon,
} from "vant";
import { request } from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  name: 'orderDetails',
  setup(__props) {

const route = useRoute();
const orderId = route.params.id;
const object = ref({
  userName: "",
  phone: "",
  address: "",
  productName: "新马泰印尼5G高速上网卡",
  flowGear: "1GB/天",
  fate: "1",
  tags: ["5G高速", "插卡激活", "可充值"],
  orderNo: "",
  payTime: "",
  payType: "",
  orderComment: "",
  payPrice: 0,
});
if (orderId) {
  request({
    url: `/order/detail/${route.params.id}`,
    method: "POST",
  }).then((res) => {
    object.value = res.data;
    request({
      url: `/order/address/detail/${res.data.addressId}`,
      method: "POST",
    }).then((res: any) => {
      object.value.userName = res.data.userName;
      object.value.phone = res.data.phone;
      object.value.address =
        res.data.province +
        res.data.city +
        res.data.country +
        res.data.detailAddress;
    });
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "订单详情",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(object.value.userName), 1),
          _createElementVNode("span", null, _toDisplayString(object.value.phone), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(object.value.address), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(object.value.productName), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(object.value.productSellPoints, (tagItem) => {
            return (_openBlock(), _createElementBlock("span", {
              key: tagItem,
              class: "tagItem"
            }, _toDisplayString(tagItem), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(object.value.flowLevel) + " × " + _toDisplayString(object.value.selectDays), 1),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, "¥" + _toDisplayString(object.value.payPrice / 100), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, "¥" + _toDisplayString(object.value.payPrice / 100), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("span", _hoisted_19, [
            (object.value.payType == '1')
              ? (_openBlock(), _createElementBlock("img", _hoisted_20))
              : (_openBlock(), _createElementBlock("img", _hoisted_21))
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("span", _hoisted_24, _toDisplayString(object.value.payTime), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("span", _hoisted_27, _toDisplayString(object.value.orderNo), 1)
        ]),
        (object.value.orderComment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("span", _hoisted_30, _toDisplayString(object.value.orderComment), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})